import Styled from "styled-components"

const TableWrap = Styled.div`
.search-container {
  margin-bottom: 20px;
  margin-top: 20px;
  height: 40px;
  position: relative;
  text-align: right;
}
.table-view-card {
  box-shadow: unset !important;
}
.table_header_noWrap {
    white-space: nowrap;
}
.common_table {
  padding: 0px 0px 0px 0px;
}
.selected-feild{
    background-color: gery;
}
.common_header {
  padding: 0px;
  font: normal normal 600 30px/37px Montserrat;
  color: #131313;
}
.pagination {
    margin-top: 10px;
    padding-right: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 20px;
    font: normal normal 600 20px Montserrat;
}
.custom_header {
    width: calc(100vw - 200px);
}
button.previous {
    background-color: transparent;
    border: none;
    font: normal normal 600 20px Montserrat;
    color: ;
    cursor: pointer;
}
.previous.disabled {
    color: #C2C2C2;
} 
button.next {
    background-color: transparent;
    border: none;
    font: normal normal 600 20px Montserrat;
    color: ;
    cursor: pointer;
}
.next.disabled {
    color: #C2C2C2;
}
.table-striped>tbody>tr:nth-of-type(odd)>* {
    color: #131313;
    --bs-table-accent-bg: #FFEED8;
}
.table-bordered>:not(caption)>*>* {
    width:200px;
    border: 1px solid #CECECE;
}
.table>:not(:first-child) {
    border-top: 1px solid #CECECE;
    vertical-align: middle;
    text-align:center;
}
.table
{
    border-color: black;
}
table {
    border-collapse: collapse;
    thead {
        background-color: #F8F9FA;
        th {
            padding: 20px !important;
            font-size: 14px;
            color: #131313;
            font:normal normal medium 24px/29px Montserrat;
            text-align:center;
            vertical-align: middle;
        }
    }
    tbody {
        tr {
            td {
                line-height: 1.42857143;
                vertical-align: middle;
                padding: 10px !important;
                font-size: 14px !important;
                color:#131313;
                white-space: normal;
                width:300px;
            }
        }
    }
    .table>:not(:first-child) {
        border-top: 1px solid currentColor;
    }
    .imgfirstLetr {
        display: inline-block;
        background-color: #c3c3c3;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        color: #fff;
        box-shadow: inherit;
        font-size: 18px;
        
        padding: 6px 6px;
        margin: 0 auto;
        text-align: center;
        vertical-align: middle;
    }
    .imgFirstLetMain {
        span {
            display: inline-block;
            vertical-align: inherit;
        }
    }
    .btn-outline-light {
        color: #212529;
        border-color: #d3d3d3;
        background-color: yellow;
        &:hover {
            color: #212529;
            background-color: #f8f9fa;
            border-color: #999;
        }
    }
    .indicator {
        background-color:yellow;
        border-radius: 50%;
        display: block;
        height: 8px;
        width: 8px;
        padding: 1px;
        position: absolute;
        bottom: 5px;
        top: inherit;
        right: -3px;
        text-align: center;
        transition: top 0.1s ease-out;
        font-size: 0.675rem;
        color: #ffffff;
    }
    .actionLink {
        svg {
            height: 25px;
            path {
                fill: #131313;
            }
        }
        padding: 5px;
    }
}

.table {
    &:not(:first-child) {
        border-top: inherit;
    }
}

@media (max-width: 991px) {
    table {
        tbody {
            tr {
                th {
                    white-space: nowrap;
                }
            }
        }
    }
}

`

export default TableWrap
